import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import CategoryProxy from '../proxies/CategoryProxy'

class CategoryService extends ServiceBase {
  getCategoryLegalFormAdjusted(params) {
    return this.applyMemoryCache(
      'domesticSearch/searchList/CategoryService/getCategoryLegalFormAdjusted',
      params,
    )(() => CategoryProxy.getCategoryLegalFormAdjusted(params))
  }

  getCompanyStatus(params) {
    return this.applyMemoryCache(
      'domesticSearch/searchList/CategoryService/getCompanyStatus',
      params,
    )(() => CategoryProxy.getCompanyStatus(params))
  }
}

export default new CategoryService()
